import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { HeartSvg, PinIcon } from "../../../public/svg/svg";
import { Badge } from "@/components/ui/badge";
import { formatValue } from "@/lib/formatHelperFunction";
import { AreaChart, DoorClosed } from "lucide-react";
import { IconArrowsMaximize, IconDoor, IconPoint } from "@tabler/icons-react";

export default function ExposeCard({
  id,
  image,
  price,
  location,
  details,
  description,
  base_rent,
  marketing_type,
  isFavorited,
  onFavoriteToggle,
  className,
}) {

  const handleCardClick = (e) => {
    umami.track(`click_on_estate`, "click")

  };

  const detailsIcons = details.split(",").map((detail) => detail.trim());
  const rooms = () => {
    return (
      <>
        <IconDoor className="inline text-gray-400 size-4 mr-1"/>
        {detailsIcons[0]}
      </>
    )
  }
  const area = () => {
    return (
      <>
        <IconArrowsMaximize className="inline text-gray-400 size-4 mr-1"/>
        {detailsIcons[1]}
      </>
    )
  }
  
  return (
    <Link
      to={`/expose/${id}`}
      className={cn(
        "relative cursor-pointer group transition-all group/card",
        className
      )}
      onClick={handleCardClick} // Navigate when the card is clicked
    >
      <div  className="relative overflow-hidden rounded-lg rounded-b-none h-[rem]">
        <img
          src={image}
          alt="Haus"
          style={{transitionDuration: "3s"}}
          className="w-full ease-linear  aspect-[8/5] object-cover rounded-sm  transition-all"
        />
        <div className="rounded-md h-fit max-h-10 flex items-center backdrop-blur-md bg-white/20 absolute bottom-2 left-2 z-20 px-2 py-1">
          <p className="font-sans text-prime-50">
            <span className="font-medium text-gray-200 text-sm">EUR</span>{" "}
            {marketing_type === "RENT" ? `${formatValue(base_rent, "currency")}/Monat` : formatValue(price, "currency")}
          </p>
        </div>
        <div
          className="rounded-xl bg-white/80 hover:shadow-xl hover:bg-white transition-all absolute top-2 right-2 z-20 p-1 group cursor-pointer"
          onClick={(e) => {
            e.preventDefault(); // Prevent default link behavior
            e.stopPropagation(); // Prevent navigation when the favorite button is clicked
            onFavoriteToggle();
          }}
        >
          <HeartSvg
            className={
              isFavorited
                ? "fill-blue-700"
                : "fill-none hover:fill-prime-700 transition-all"
            }
          />
        </div>
      </div>
      <div className="p-2 relative ">
        <div className="flex items-center justify-between gap-1">
          <div className="flex items-center gap-1">
            <PinIcon />
            <p className="font-sans text-sm text-gray-600 truncate">{location}</p>
          </div>
          <div className=" font-sans">
          {marketing_type === "RENT" ? (
            <Badge className="bg-prime-50 text-[#e95c0c] font-normal hover:bg-white shadow-none">
              Mieten
            </Badge>
          ) : (
            <Badge className="bg-prime-50 text-prime-700 font-normal hover:bg-prime-100 shadow-none">
              Kaufen
            </Badge>
          )}
        </div>
        </div>
        <p
          className="font-medium text-dark-100 group-hover/card:text-prime-700 transition-all line-clamp-2 overflow-hidden text-ellipsis pt-1"
          style={{ minHeight: "3em" }}
        >
          {description}
        </p>
        <div className="flex justify-between">
        <div className="flex items-center gap-1">
          <p className="font-sans text-sm text-gray-700 py-2">{rooms()}</p>
          <IconPoint className="inline text-gray-300 fill-gray-300 size-3 "/>
          <p className="font-sans text-sm text-gray-700 py-2">{area()}</p>
        </div>
        </div>
      </div>
    </Link>
  );
}
